import { render, staticRenderFns } from "./TenderLegal.vue?vue&type=template&id=41d77a48"
import script from "./TenderLegal.vue?vue&type=script&lang=js"
export * from "./TenderLegal.vue?vue&type=script&lang=js"
import style0 from "./TenderLegal.vue?vue&type=style&index=0&id=41d77a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports